// Errors React throws when the browser (e.g. Chrome Translate) has rewritten
// DOM nodes React owns. A remount recovers, so these are safe to retry.
export default function isDetachedNodeError(error) {
  if (!error) return false
  const message = typeof error.message === 'string' ? error.message : ''
  return error.name === 'NotFoundError' || /removeChild|insertBefore/.test(message)
}
